import { RouteObject } from 'react-router-dom';
import mainRoutes from './main';
import mockDeviceDataRoutes from './mockDeviceData';
import ccRoutes from './cc';
import openPlatformRoutes from './openPlatform';

export default [...mainRoutes, ...mockDeviceDataRoutes, ...openPlatformRoutes, ...ccRoutes] as RouteObject[];
